/* eslint-disable */ /* Disabled eslint because of import orders */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import anime from "animejs";

import PerfectScrollbar from "vue2-perfect-scrollbar";

Vue.use(PerfectScrollbar);

/*
 * Core packages
 */

import Vue from "vue";
import App from "@/App";
import router from "@/router";
import store from "@/store";
import i18n from "@/lang/lang";
/*
 * EventBus for global event handling
 */

import EventBus from "@/components/shared/eventbus";

/*
 * Audioplayer for global audi playing
 */

import AudioPlayer from "@/components/shared/audio";

/*
 * IE Polyfill
 */

import "./polyfill";

/*
 * Other packages
 */

import { VTooltip, VPopover, VClosePopover } from "v-tooltip";
import VueLineClamp from "vue-line-clamp";
import VueGtag from "vue-gtag";
import "@/assets/css/global.styl";
import uuidv4 from "uuid/v4";
import TextHighlight from "vue-text-highlight";
import Vuebar from "vuebar";
import VueVirtualScroller from "vue-virtual-scroller";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import VueCookies from "vue-cookies";
import * as Sentry from "@sentry/browser";
import proTypes from "@/pro_types.js";
import { Vue as VueIntegration } from "@sentry/integrations";
import "./globalComponents";
import CONSTANTS from "@/constants";
import { fromLongToShort } from "@/components/shared/languageCodes";

// YBUG
import Ybug from "./ybug.js";

Vue.use(Ybug, {
  id: "2swkxjr1gh5dn3rvk72w",
  settings: {
    hide_launcher: true,
    language_override:
      fromLongToShort[store.getters["settings/getSiteLanguage"]],
    email: true,
    email_required: true,
    nps: true,
  },
});

Vue.use(VueCookies);

Vue.$cookies.config("365d");

import Meta from "vue-meta";
Vue.use(Meta, {
  keyName: "metaInfo",
});

import VueHead from "vue-head";
Vue.use(VueHead);

const isDev = process.env.NODE_ENV !== "production";

// Sentry crash report
if (process.env.NODE_ENV === "production") {
  Sentry.init({
    // ignored sentry issues
    ignoreErrors: [
      // microphone issues
      "NotAllowedError: The request is not allowed by the user agent or the platform in the current context.",
      "NotAllowedError: Registration failed - permission denied",
      "NotAllowedError: Permission denied by system",
      "NotAllowedError: Permission dismissed",
      "NotAllowedError: Permission denied",
      "NotFoundError: Requested device not found",
      `'microphone' (value of 'name' member of PermissionDescriptor) is not a valid value for enumeration PermissionName.`,
      // global error handling issue
      "Non-Error promise rejection captured with keys: code, message",
      "Non-Error promise rejection captured with keys: code",
      "[CF] Failed to load configs, check API key",
    ],
    beforeSend: (event, hint) => {
      const error = hint.originalException;
      // ignore sentry issues on this pages
      if (
        location.href.includes("cs4.html") ||
        location.href.includes("cs123.html")
      ) {
        return null;
      }
      console.log(error && error.message);
      const ignoredErrors = [
        "Cannot read properties of undefined (reading 'order')",
        "Cannot read properties of null (reading 'focus')",
        "this.context is null",
        '_this4.$refs["pager-".concat(...)][0] is undefined',
        "Cannot read properties of undefined (reading 'offsetLeft')",
        "NotAllowedError: Permission denied",
        "[CF] Failed to load config files, are you using a correct API key?",
        "[CF] Failed to load configs, check API key",
      ];
      if (
        error &&
        error.message &&
        (ignoredErrors.includes(error.message) ||
          error.message.includes("Navigation cancelled") ||
          error.message.includes(
            "Non-Error promise rejection captured with value"
          ) ||
          error.message.includes("Redirected when going from") ||
          error.message.includes("undefined is not iterable") ||
          error.message.includes(
            "'block' member of ScrollIntoViewOptions 'center' is not a valid value"
          ))
      ) {
        return null;
      }
      return event;
    },
    dsn: "https://1653aaa76ee04b1b93d147fb32bb2106@o462477.ingest.sentry.io/5514413",
    integrations: [
      new VueIntegration({
        Vue,
        logErrors: true,
      }),
    ],
  });
} else {
  console.debug("Not configuring Sentry, environment is", process.env.NODE_ENV);
}

Vue.config.devtools = isDev;
Vue.config.performance = isDev;
Vue.config.productionTip = false;

Vue.prototype.$constants = CONSTANTS;
Vue.prototype.$eventBus = EventBus;
Vue.prototype.$anime = anime;
Vue.prototype.$uuid = uuidv4;
Vue.prototype.$audio = AudioPlayer;
Vue.prototype.$proTypes = proTypes;
Vue.use(VueVirtualScroller);
Vue.use(Vuebar);
Vue.use(VTooltip);
Vue.use(VueLineClamp, {
  importCss: true,
});

Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GTAG_ANALYTICS_KEY },
  bootstrap: false,
  pageTrackerTemplate(to) {
    return {
      page_title: to.name,
      page_path: to.path,
    };
  },
});

// moment imports
import VueMoment from "vue-moment";
const moment = require("moment");

Vue.use(VueMoment, { moment });

Vue.directive("tooltip", VTooltip);
Vue.directive("close-popover", VClosePopover);
Vue.component("v-popover", VPopover);
Vue.component("text-highlight", TextHighlight);

const urlParams = new URLSearchParams(window.location.search);
const paramCode = urlParams.get("code");
const paramScope = urlParams.get("scope");
const paramSessionState = urlParams.get("session_state");

if (!(paramCode && paramScope && paramSessionState)) {
  const HelloJs = require("hellojs");
  const VueHello = require("vue-hellojs");

  HelloJs.init(
    {
      // google: process.env.VUE_APP_GOOGLE_ID,
      facebook: "200500380113638",
    },
    { redirect_uri: "/auth" }
  );
  Vue.use(VueHello, HelloJs);
}

// import GAuth from "vue-google-oauth2";
// const gauthOption = {
//   clientId: process.env.VUE_APP_GOOGLE_ID,
//   scope: "https://www.googleapis.com/auth/contacts.readonly",
//   prompt: "select_account"
// };
// Vue.use(GAuth, gauthOption);
/* eslint-disable no-new */
const app = new Vue({
  el: "#app",
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

export default app;
